import { Input } from '@aqarmap/aqarmap-ui';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  addListingDetailsType,
  CustomFieldsType,
  ListingDetailsType,
} from '~/modules/addListing/types';
import { handleAttributeChange } from '~addListing/utils/handleAttributeChange';

const RoomsNumber = ({
  listing,
  customFieldsData,
  errorAttributeIds,
  setErrorAttributeIds,
}: {
  listing: ListingDetailsType;
  customFieldsData: { attributes: CustomFieldsType[] };
  errorAttributeIds: number[];
  setErrorAttributeIds: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const roomsKey = 'rooms';
  const { t } = useTranslation('app');
  const listingPropertyTypeId = listing?.property_type.id;
  const roomsNumberData = customFieldsData.attributes?.find(
    (field: CustomFieldsType) => field.name === roomsKey,
  );
  const roomsNumberId = Number(roomsNumberData?.id);
  const isError = errorAttributeIds.includes(roomsNumberId);

  const renderRooms = Object.values(
    roomsNumberData?.virtualPropertyTypesIds || {},
  ).includes(listingPropertyTypeId);

  const { setValue, getValues } = useFormContext<addListingDetailsType>();
  const defaultRoomsNumberValue =
    listing?.attributes.find((att) => att.custom_field.id === roomsNumberId)
      ?.value || 0;

  if (!renderRooms) return null;

  useEffect(() => {
    setValue(
      'attributes',
      handleAttributeChange(
        getValues('attributes'),
        roomsNumberId,
        defaultRoomsNumberValue,
      ),
    );
  }, [isError]);

  return (
    <Input
      label={{
        text: t('roomsNumber'),
        className: 'text-title_4 text-black',
      }}
      field={{
        placeholder: t('roomsNumberPlaceholder'),
        className:
          'text-gray__dark_2 text-gray__dark_2 placeholder:text-gray__dark_1 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-moz-appearance:textfield]',
        type: 'number',
        defaultValue:
          defaultRoomsNumberValue !== 0 ? defaultRoomsNumberValue : '',
        onChange: (e) => {
          const value = Number(e.target.value);
          if (value >= 0)
            handleAttributeChange(
              getValues('attributes'),
              roomsNumberId,
              value,
            );
          else handleAttributeChange(getValues('attributes'), roomsNumberId, 0);
        },
        min: 0,
        onFocus: () =>
          setErrorAttributeIds((prev) =>
            prev.filter((id) => id !== roomsNumberId),
          ),
        onWheel: (e) => (e.target as HTMLInputElement).blur(),
      }}
      error={isError ? t('roomsNumberError') : ''}
    />
  );
};

export default RoomsNumber;
